import { AxiosInstance, AxiosRequestConfig } from "axios"

import { OptimizedFavouritesListItemSearchResponse } from "./getSpecificFavoriteListWithId"

export interface FavouritesListItemSearchParams {
  date: string | null
  favouriteListId: string
  guestCount: number
  numberOfdays?: number | null
  propertyIds: string[]
  isgoogle: boolean
}

export interface FavoriteListItemSearchRequest
  extends Partial<AxiosRequestConfig> {
  params: FavouritesListItemSearchParams
}

// new optimzed API
export function searchInFavoriteListOptimizedApi(
  { params }: FavoriteListItemSearchRequest,
  axiosInstance: AxiosInstance,
): Promise<OptimizedFavouritesListItemSearchResponse> {
  const url = `/user/favouritelist/propertysearchinlist`

  return axiosInstance({
    data: params,
    method: "post",
    url,
  }) as Promise<OptimizedFavouritesListItemSearchResponse>
}
